import React, { memo } from 'react'

import { Container, Box, Grid } from '@mui/material'
import Image from '@v4/components/common/Image'
import EditableHTML from '@v4/components/common/EditableHTML'
import SortHandler from '@v4/components/common/SortHandler'
import clsx from 'clsx'
import EditableContainer from '@v4/components/common/EditableContainer'
import { DEFAULT_ORDER } from './Header.const'
import { useHeader } from './Header.hooks'

const Header = props => {
	const [
		{
			classes,
			text,
			textConfig,
			direction,
			alignment,
			href,
			image,
			withImage,
			isCentered,
			textAlignment,
			textEditable,
			textKey,
			sortHandlerParentRef,
		},
		{ handleImageClick, handleTextClick, handleTextChange },
	] = useHeader(props)

	return (
		<Box className={clsx(classes.root, 'section-header')}>
			<Container className="section-header-content">
				<Box display="flex" color="text.primary" alignItems="center">
					<Grid
						className={clsx(classes.container, classes[alignment])}
						container
						alignItems="center"
						spacing={4}
						wrap={!text ? 'nowrap' : undefined}
						ref={sortHandlerParentRef}
					>
						<SortHandler
							parentRef={sortHandlerParentRef}
							defaultOrder={DEFAULT_ORDER}
							direction={direction}
						>
							<Grid
								className={clsx(classes.logoWrap, 'header-logo-container')}
								size={{
									sm: !isCentered ? 6 : 'auto',
								}}
							>
								<Box className={clsx(classes.image, 'header-image')}>
									{withImage && (
										<a href={href} target="_top">
											<Image metaData={image} onClick={handleImageClick} />
										</a>
									)}
								</Box>
							</Grid>
							<Grid
								className={classes.empty}
								size={{
									sm: isCentered ? 6 : false,
								}}
							>
								<Box />
							</Grid>

							<Grid
								className={clsx(
									classes.textWrap,
									!text && isCentered && classes.empty,
									'header-text-container',
								)}
								size={{
									xs: 12,
									sm: 6,
								}}
							>
								<EditableContainer
									visible={!!text}
									fieldConfig={textConfig}
									onAdd={handleTextChange}
									editable={textEditable}
								>
									<EditableHTML
										key={textKey}
										align={textAlignment}
										displayEmpty
										className={clsx(classes.text, 'header-text-block')}
										html={text}
										onClick={handleTextClick}
										editable={textEditable}
										onChange={handleTextChange}
									/>
								</EditableContainer>
							</Grid>
						</SortHandler>
					</Grid>
				</Box>
			</Container>
		</Box>
	)
}

export default memo(Header)
